import React, { useEffect, useState } from "react";
import Preloading from "../../../components/basics/Preloading";
import { Link, useParams } from "react-router-dom";
import back from "../../../assets/images/icons/arrow-right2.svg";
import methods from "../../../services/utility";
import apiMethod from "../../../services/api-service";
import EditModalAddress from "./EditModalAddress";
import DeleteAddressModal from "./DeleteAddressModal";
import AddAddressModal from "./AddAddressModal";

const MerchantAddress = () => {
  const [loading, setLoading] = useState(false);
  const { branchId, id } = useParams();
  const [gridDataAdress, setGridDataAdress] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [merchantInfo, setMerchantInfo] = useState({});
  const [filterModel, setFilterModel] = useState({
    merchantId: id,
    size: 20,
    part: 1,
    title: "",
  });

  const getAdress = async () => {
    const resp = await apiMethod.getMerchantAdresses(
      filterModel.merchantId,
      filterModel.size,
      filterModel.part,
      filterModel.title
    );
    if (methods.showApiErrors(resp)) {
      setGridDataAdress(resp.data);
      setMerchantInfo(resp.merchant);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getAdress();
      setLoading(false);
    };
    bindData();
  }, [branchId, id]);

  const handleClose = () => setShowEditModal(null);
  const handleShow = (id) => {
    setShowEditModal(id);
  };

  const handleDeleteClose = () => setShowDeleteModal(null);
  const handleDeleteShow = (id) => {
    setShowDeleteModal(id);
  };

  const handleAddAddressClose = () => setShowAddAddressModal(null);

  const editItem = (id) => {
    handleShow(id);
  };

  const selectAddressDelete = (id) => {
    handleDeleteShow(id);
    setSelectedAddressId(id);
  };

  const deleteAddress = async () => {
    setLoading(true);
    const resp = await apiMethod.removeAddress(selectedAddressId);
    if (!methods.showApiErrors(resp)) return false;
    setLoading(false);
    handleDeleteClose();
    await getAdress();
  };

  const resetFilters = () => {
    filterModel.merchantId = id;
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.title = "";
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    setLoading(true);
    await getAdress();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getAdress();
    setLoading(false);
  };


  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/merchantWallet`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/merchantWallet`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                <span>
                  {merchantInfo?.firstName &&
                    `آدرس های ${merchantInfo.firstName} ${merchantInfo.lastName}`}
                </span>
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <span>
                {merchantInfo?.firstName &&
                  `آدرس های ${merchantInfo.firstName} ${merchantInfo.lastName}`}
              </span>
            </div>
            <div className="salesearchsection">
              <div className="row g-1">
                <div className="col-12 col-md-4 col-lg-2">
                  <label htmlFor="searchInput" className="form-label">
                    عنوان آدرس
                  </label>
                  <div className="hstack">
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.title}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          title: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                </div>
                <div
                  className="col-12 col-md-4 col-lg-2"
                  style={{ marginTop: "35px" }}
                >
                  <button
                    type="button"
                    className="btn btn-purple me-1"
                    onClick={searchItem}
                    >
                    <i className="bi bi-search"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-info"
                    onClick={clearSearch}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
                <div className="col-12 col-md-6 col-lg-8">
                  <div className="createButton">
                    <button
                      onClick={() => {
                        setShowAddAddressModal(true);
                      }}
                      className="btn btn-outline-purple custome-btn"
                      type="button"
                    >
                      <span className="align-middle d-inline-block">
                        آدرس جدید
                      </span>{" "}
                      <i className="bi bi-plus-circle align-middle"></i>
                    </button>
                  </div>
                  <AddAddressModal
                    show={showAddAddressModal}
                    onHide={handleAddAddressClose}
                    merchantInfo={merchantInfo}
                    setLoading={setLoading}
                    getAdress={getAdress}
                  />
                </div>
              </div>
            </div>
            {gridDataAdress.length < 1 ? (
              <span className="d-block text-center">
                آدرسی برای این مشتری ثبت نشده است...
              </span>
            ) : (
              <table className="table table-striped table-md align-middle">
                <thead className="">
                  <tr>
                    <th scope="col vertical-center">ردیف</th>
                    <th scope="col vertical-center">عنوان آدرس</th>
                    <th scope="col vertical-center">آدرس</th>
                    <th scope="col vertical-center" width="100px">
                      عملیات
                    </th>
                  </tr>
                </thead>
                <tbody className="">
                  {gridDataAdress?.map((item, index) => (
                    <tr key={item.id}>
                      <th scope="row">
                        {(filterModel.part - 1) * filterModel.size + index + 1}
                      </th>
                      <td>{item.title}</td>
                      <td>{item.address}</td>
                      <td>
                        <button
                          onClick={() => editItem(item.id)}
                          className="btn btn-sm btn-outline-purple mx-1"
                          type="button"
                        >
                          <i className="bi bi-pencil-square"></i>
                        </button>
                        <EditModalAddress
                          show={showEditModal === item.id}
                          onHide={handleClose}
                          setLoading={setLoading}
                          getAdress={getAdress}
                          id={showEditModal}
                        />
                        <button
                          onClick={() => selectAddressDelete(item.id)}
                          className="btn btn-sm btn-outline-danger"
                          type="button"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                        <DeleteAddressModal
                          show={showDeleteModal === item.id}
                          onHide={handleDeleteClose}
                          deleteAddress={deleteAddress}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        }
      </>
    );
  };

  return <>{renderItems()}</>;
};

export default MerchantAddress;
